//
//
//
//
//
//
//
//
//
//
//
//

const { DateTime } = require('luxon')

export default {
  props: ['market', 'event', 'outcome', 'fullname', 'hideTitle', 'inverse', 'sp', 'transparent'],
  data() {
    return {
      lastUpdate: +new Date(),
      currentTime: +new Date(),
      showMovement: false,
      loading: true,
      movement: 0,
      balance: null
    }
  },
  filters: {
    format_odds(value, oddsFormat) {
      return _.get(value, 'display_odds.' + oddsFormat, parseFloat(value.odds).toFixed(2))
      //return parseFloat(value.odds).toFixed(2)
    }
  },
  watch: {
    outcome: function (newOutcome, oldOutcome) {
      this.oddsHistory = _.union(this.oddsHistory, [parseFloat(newOutcome.odds)])
      this.oddsHistory = _.takeRight(this.oddsHistory, 2)

      //this.oddsHistory.push(parseFloat(newOutcome.odds))
      if (parseFloat(newOutcome.odds) != parseFloat(oldOutcome.odds)) {
        this.showMovement = DateTime.now().toFormat('mm:ss')
        this.lastUpdate = +new Date()
      }
      if (parseFloat(newOutcome.odds) != _.last(this.oddsHistory)) {
        //this.lastUpdate = +new Date();
        //this.showMovement = DateTime.now().toFormat('mm:ss')
      }
      if (_.first(this.oddsHistory) != _.last(this.oddsHistory)) {
        //console.log('oddsHistory', this.oddsHistory, _.first(this.oddsHistory), (+new Date() - this.lastUpdate)/1000)
      }

      let newOdds = _.first(this.oddsHistory)
      let oldOdds = _.last(this.oddsHistory)
      if (newOdds > oldOdds) {
        this.movement = 1
      } else if (newOdds < oldOdds) {
        this.movement = -1
      } else {
        this.movement = 0
      }
    }
  },
  computed: {
    disabled() {
      let outcomeAlt = this.outcomeAlt
      
      if(!_.get(outcomeAlt, 'odds'))
        return true;

      if(_.get(outcomeAlt, 'suspended') || !_.get(outcomeAlt, 'visible'))
        return false;
      
      if(_.get(outcomeAlt, 'odds') == 'SP')
        return false;

        
      return (!_.isString(_.get(outcomeAlt, 'odds')) && _.get(outcomeAlt, 'odds') <= 1 && _.get(outcomeAlt, 'odds') > 0)
      return false;
    },
    outcomeAlt() {
      let outcome = _.clone(this.outcome)
      if(this.sp) {
        outcome.odds = 'SP'
        outcome.display_odds = {
            "decimal": "SP",
            "fractional": "SP",
            "american": "SP"
        }
        return outcome
      }
      if (_.get(this.selectionsLive, outcome.id)) {
        outcome.odds = _.get(this.selectionsLive, outcome.id + '.odds')
        outcome.display_odds = _.get(this.selectionsLive, outcome.id + '.display_odds')
      }
      return outcome
    },
    direction() {
      if (this.movement !== 0) {
        if (this.movement > 0) {
          return '&#129045;'
        }
        if (this.movement < 0) {
          return '&#129047;'
        }
      }
      return ''
    },
    selections() {
      return this.$store.state.betslip.selections
    },
    selected() {
      let mySelections = _.map(this.$store.state.betslip.selections, 'outcome.id')
      return _.includes(mySelections, this.outcome.id)
    },
    selectionsLive() {
      return this.$store.state.betslip.selectionsLive
    }
  },
  mounted() {
    this.oddsHistory = []
    this.lastUpdate = +new Date()

    setInterval(() => {
      this.currentTime = +new Date()
    }, 5000)
  },
  methods: {
    formatOutcomeName(outcomeAlt) {
      let name = this.fullname ? _.get(outcomeAlt, 'fullname', outcomeAlt.name) : outcomeAlt.name;
      if(_.includes(['Home', 'Draw', 'Away', 'Yes', 'No'], name)) {
        let trans = this.$t('BTN_'+name)
        if(trans != 'BTN_'+name)
          name = trans
      }
      if(_.includes(['1 Blue', '2 Green', '3 Yellow', '4 Red'], name)) {
        name = this.$t(name)
      }
      return name
    },
    addToSlip(event, market, outcome) {
      this.$store.commit('setBetSlipType', null)
      if(this.sp) {
        outcome.is_starting_price = true
        outcome.odds = 'SP'
        outcome.display_odds = {
            "decimal": "SP",
            "fractional": "SP",
            "american": "SP"
        }
      }

      //console.log('addToSlip', event, market, outcome)
      if (this.selected) {
        this.$store.commit('betslip/remove', { event: event, market: market, outcome: outcome })
      } else {
        if (_.size(this.selections) == 1 && this.$device.isMobile) {
          this.$store.commit('betslip/toggleBetslip', false)
        }
        if (_.size(this.selections) == 0) {
          let defaultStake = 10

          //If <10, default 10
          if (_.get(this.$store.state, 'betslip.stakeSingle') < defaultStake) {
            this.$store.commit('betslip/setStakeSingle', defaultStake)
          }
          if (_.get(this.$store.state, 'betslip.stakeCombi') < defaultStake) {
            this.$store.commit('betslip/setStakeCombi', defaultStake)
          }
          if (_.get(this.$store.state, 'betslip.stakeSystem') < defaultStake) {
            this.$store.commit('betslip/setStakeSystem', defaultStake)
          }

          //if >10, use latest stake. 
          let lastUsedStake = _.get(this.$store.state, 'betslip.lastUsedStake');
          if(!_.isNil(lastUsedStake) && lastUsedStake > defaultStake) {
            this.$store.commit('betslip/setStakeSingle', lastUsedStake)
            this.$store.commit('betslip/setStakeCombi', lastUsedStake)
            this.$store.commit('betslip/setStakeSystem', lastUsedStake)
          }

          if (this.$device.isMobile) {
            this.$store.commit('betslip/toggleBetslip', true)
          }
        }

        let eventTmp = _.omit(event, ['markets', 'market_groups']);
        this.$store.commit('betslip/add', { event: eventTmp, market: market, outcome: outcome })

        this.$root.$emit('selection_added')
      }
    }
  }
}
